import Vue from 'vue'
import authType from '@/store/type/authType'
import UsersApiClient from '@/api/RestApi/UsersApiClient'
import store from '@/store/store'
import Config from '@/config.loader'

function Impersonate() {
    const self = this
    self.state = Vue.observable({
        isActive: false,
        isLoading: false,
    })

    self.storeCurrentOriginalToken = (userId) => {
        window.localStorage.setItem(
            'impersonate',
            store.getters[authType.getters.GET_REFRESH_TOKEN]
        )
        window.localStorage.setItem('impersonateUser', userId)
    }

    self.login = async (userId) => {
        self.storeCurrentOriginalToken(userId)

        const loginResponse = await UsersApiClient.loginAs(userId)

        await store.dispatch(
            authType.actions.LOGIN_WITH_REFRESH_TOKEN,
            loginResponse.refresh
        )
        self.state.isActive = true
    }

    self.loginToFrontend = () => {
        const originalToken = window.localStorage.getItem('impersonate')

        const host = Config.getConfigValue('VUE_APP_PUBLIC_FE_BASE')
        const url = `${host}/login/callback?sso_token=${
            store.getters[authType.getters.GET_REFRESH_TOKEN]
        }&impersonate=${originalToken}`
        window.location.href = url
    }

    self.logout = async () => {
        window.localStorage.removeItem('impersonate')
        self.state.isActive = false
        self.state.isLoading = false
    }

    self.exit = async () => {
        self.state.isLoading = true
        const refresh = window.localStorage.getItem('impersonate')
        await store.dispatch(authType.actions.LOGIN_WITH_REFRESH_TOKEN, refresh)
        window.localStorage.removeItem('impersonate')
        self.state.isActive = false
        self.state.isLoading = false
    }

    self.frontendLogout = async () => {
        const host = Config.getConfigValue('VUE_APP_PUBLIC_FE_BASE')
        const url = `${host}/login/callback?impersonate_logout=1`
        window.location.href = url
    }

    self.frontendExit = async () => {
        const host = Config.getConfigValue('VUE_APP_PUBLIC_FE_BASE')
        const url = `${host}/login/callback?impersonate_exit=1`
        window.location.href = url
    }

    self.state.isActive = !!window.localStorage.getItem('impersonate')
}

Vue.use({
    install(Vue) {
        Vue.prototype.$impersonate = new Impersonate()
    },
})
